export enum AuthResponseErrorType {
  NoResponse = 1,
  ErrorResponse = 2,
  ExpiredResponse = 3,
}
